// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"a9007436","229":"6116d723","410":"4c27f0d0"}[chunkId] + ".chunk.css";
};